module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ccfbf9a3edc4c5c792a2ae448d853e16.gif";